import React, { memo } from 'react'
import tw from 'twin.macro'
import { Skeleton } from './Skeleton'

interface Props {
  /** How many label + field pairs to sketch under the title. */
  fields?: number
  dataTestId?: string
}

/**
 * The loading shape of a `SectionCard` holding a form: a title line, a shorter subtitle line,
 * then `fields` label-and-input pairs at the real 36px field height, so the page keeps its
 * final silhouette while the data arrives.
 */
const SectionCardSkeletonComponent = ({ fields = 3, dataTestId }: Props) => {
  return (
    <div
      role="status"
      aria-label="Loading"
      css={tw`rounded-lg border border-solid border-shades-100 bg-shades-0 p-6`}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      <Skeleton className={tw`h-5 w-48`} />
      <Skeleton className={tw`mt-2 h-4 w-72`} />
      <div css={tw`mt-6 flex flex-col gap-4`}>
        {Array.from({ length: fields }).map((_, index) => {
          return (
            <div key={index}>
              <Skeleton className={tw`mb-2 h-4 w-32`} />
              <Skeleton className={tw`h-9 w-full`} />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export const SectionCardSkeleton = memo(SectionCardSkeletonComponent)
